import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";
import { useGroupSearch } from "hooks/citajteo/dl_group/useGroupSearch";
import { DlGroup } from "type/dl_group/dl_group.type";

const DlGroupList: React.FC = () => {
  const dlGroups = useGroupSearch();

  return (
    <Content>
      <ContentInner>
        <NewItem>
          <RouterLink to="/admin-dashboard/dl-group-edit">novo</RouterLink>
        </NewItem>

        {dlGroups &&
          dlGroups.items.length > 0 &&
          dlGroups.items.map((item: DlGroup) => (
            <ListItem key={item.slug}>
              <RouterLink to={`/admin-dashboard/dl-group-edit/${item.id}`}>
                polja
              </RouterLink>
              <br />
              {item.slug.replace(/-/g, " ")}
              <DeleteText>obriši</DeleteText>
            </ListItem>
          ))}
      </ContentInner>
    </Content>
  );
};

export default DlGroupList;

const Content = styled.div``;

const ContentInner = styled.div`
  width: 90%;
`;

const NewItem = styled.div`
  margin-top: 0;
`;

const ListItem = styled.div`
  margin-top: 1em;
  width: 100%;
  line-height: 1.5em;
`;

const DeleteText = styled.span`
  margin-left: 3%;
  cursor: pointer;
  color: darkgrey;
`;
